export { default } from '@/shared/components/UserAvatar';
export type { UserAvatarProps } from '@/shared/components/UserAvatar';
